export const getBaseUrl = () => {
    // Server-side: process.env is fully available
    if (typeof window === "undefined") {
        return process.env.NEXT_PUBLIC_BASE_URL
    }
    // Client-side: only NEXT_PUBLIC_ vars are available
    return '';
};